"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
var _icons = require("../icons");
var _chips_theme = require("./chips_theme");
var _excluded = ["onRemove"]; // @ts-expect-error - TS7016 - Could not find a declaration file for module './chips_theme'. 'src/azalea/components/chips_theme.js' implicitly has an 'any' type.
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var stopEvent = function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
};
var statusTheme = function statusTheme(flavor, themeName) {
  var statusMapping = themeName !== _constants.ReskinThemes.BIRCH ? _chips_theme.azaleaTheme : _chips_theme.birchTheme;
  return statusMapping[flavor] || {};
};
var Chip = exports.Chip = (0, _styledComponents.withTheme)(function (props) {
  var _props$theme, _props$theme2;
  var onRemove = props.onRemove,
    nonFunctionProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var maxWidth = props.maxWidth || 'calc(100% - 5px)'; // 5px to account for 2.5px margin on either side
  var hoverColor = props.readonly && ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.name) !== _constants.ReskinThemes.BIRCH ? 'initial' : statusTheme(props.status, (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.name).hoverColor;
  return /*#__PURE__*/React.createElement(ChipWrapper, (0, _extends2["default"])({}, nonFunctionProps, {
    onMouseDown: stopEvent,
    maxWidth: maxWidth,
    hoverable: props.hoverable === undefined ? true : props.hoverable,
    hoverColor: hoverColor
  }), /*#__PURE__*/React.createElement(ChipText, (0, _extends2["default"])({}, nonFunctionProps, {
    onMouseDown: stopEvent,
    "data-provides": "chip-text"
  }), props.text), /*#__PURE__*/React.createElement(ChipRemoveLink, null, !props.readonly && /*#__PURE__*/React.createElement(CloseIcon, {
    size: 16,
    onClick: function onClick(e) {
      stopEvent(e);
      props.onRemove(e);
    },
    status: props.status,
    theme: props.theme
  })));
});
var ChipWrapper = _styledComponents["default"].span.attrs(function (props) {
  return {
    'data-test-role': 'react-chosen-multiselect-option',
    title: props.title || props.text
  };
}).withConfig({
  displayName: "chip__ChipWrapper"
})(["display:inline-flex;", " max-width:", ";background:", ";border:1px solid ", " ", ";", " color:", ";font-size:", ";font-weight:", ";border-radius:", "px;vertical-align:middle;padding:2px 12px;margin:2.5px;", ""], /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.maxWidth;
}, function (props) {
  var _props$theme3;
  return (
    // @ts-expect-error - TS2339 - Property 'status' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>, "key" | keyof HTMLAttributes<HTMLSpanElement>> & { ...; } & { ...; } & object, DefaultTheme>'.
    statusTheme(props.status, (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.name).backgroundColor
  );
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  var _props$theme4;
  return statusTheme(props.status, (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.name).borderColor;
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  var _props$theme5;
  return statusTheme(props.status, (_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.name).textColor;
}, _constants.fontSize.small, _constants.fontWeight.normal, function (props) {
  var _props$theme6;
  return ((_props$theme6 = props.theme) === null || _props$theme6 === void 0 ? void 0 : _props$theme6.name) !== _constants.ReskinThemes.BIRCH ? "100" : "5";
}, function (props) {
  var _props$theme7;
  return (
    // @ts-expect-error - TS2339 - Property 'hoverable' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>, "key" | keyof HTMLAttributes<HTMLSpanElement>> & { ...; } & { ...; } & object, DefaultTheme>'.
    props.hoverable && "\n    &:hover,\n    &:active,\n    &:focus {\n".concat("\n      background: ", props.hoverColor, ";\n      border-color: ").concat(
    // @ts-expect-error - TS2339 - Property 'status' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>, "key" | keyof HTMLAttributes<HTMLSpanElement>> & { ...; } & { ...; } & object, DefaultTheme>'.
    statusTheme(props.status, (_props$theme7 = props.theme) === null || _props$theme7 === void 0 ? void 0 : _props$theme7.name).hoverBorderColor, ";\n    }\n  ")
  );
});
var ChipText = _styledComponents["default"].span.withConfig({
  displayName: "chip__ChipText"
})(["display:inline-block;text-decoration:", ";white-space:nowrap;overflow-x:hidden;text-overflow:ellipsis;vertical-align:inherit;"], function (props) {
  return (
    // @ts-expect-error - TS2339 - Property 'status' does not exist on type 'ThemedStyledProps<Pick<DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>, "key" | keyof HTMLAttributes<HTMLSpanElement>> & { ...; }, DefaultTheme>'.
    props.status === 'unavailable' ? 'line-through' : 'initial'
  );
});
var ChipRemoveLink = (0, _styledComponents["default"])(ChipText).attrs({
  'data-test-role': 'react-remove-option'
}).withConfig({
  displayName: "chip__ChipRemoveLink"
})(["padding-left:", ";color:", ";margin-right:-6px;display:inline-flex;align-items:center;min-height:20px;min-width:fit-content;"], _constants.padding.tiny, _constants.colors.darkestGrey);
ChipRemoveLink.displayName = 'ChipRemoveLink';
var CloseIcon = (0, _styledComponents["default"])(_icons.XIcon).withConfig({
  displayName: "chip__CloseIcon"
})(["padding:2px;path{fill:", ";}&:hover{path{fill:", ";}background:", ";border-radius:50%;}"], function (props) {
  var _props$theme8;
  return statusTheme(props.status, (_props$theme8 = props.theme) === null || _props$theme8 === void 0 ? void 0 : _props$theme8.name).iconColor;
}, function (props) {
  var _props$theme9;
  return statusTheme(props.status, (_props$theme9 = props.theme) === null || _props$theme9 === void 0 ? void 0 : _props$theme9.name).iconHoverColor;
}, function (props) {
  var _props$theme10;
  return statusTheme(props.status, (_props$theme10 = props.theme) === null || _props$theme10 === void 0 ? void 0 : _props$theme10.name).iconHoverBGColor;
});
CloseIcon.displayName = 'CloseIcon';